<div #ngContentRef><ng-content></ng-content></div>
<div class="fc-responsive-ag-grid-mode-button" *ngIf="!ngContentRef.hasChildNodes() && !isMobileWidth">
    <button class="change-mode-button switch-to-desktop-mode"
       *ngIf="gridOptions.isMobileMode"
       (click)="toggleViewMode()"></button>
    <button class="change-mode-button switch-to-mobile-mode"
       *ngIf="!gridOptions.isMobileMode"
       (click)="toggleViewMode()"></button>
</div>